// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"867b0c8c","239":"e943a090","396":"68fe15a5","453":"73999408","455":"1bc105ae","977":"94782c42"}[chunkId] + ".chunk.js";
};